import request from '@/utils/request'

// 获取分页热门医生
export function getSort(data) {
  return request({
    url: '/api/doctor/sort',
    method: 'get',
    params: data,
  })
}
